import { groupBy } from 'lodash'
import { ModalUtils } from '@/shared/util/modal-utils'
import { StoreUtils } from '@/shared/util/store-utils'
import axios from 'axios'
import { EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

export class PromiseUtils {
    static isEntityIdentifierWithErrorResponse(payload: any): boolean {
        return typeof payload === 'object' &&
            payload.hasOwnProperty('id') &&
            payload.hasOwnProperty('errorMessage')
    }

    static handleAxiosError(error: any, excludedResponseStatuses?: number[]): void {
        if (!axios.isCancel(error)) {
            if (axios.isAxiosError(error)) {
                if (error.response && excludedResponseStatuses?.includes(error.response.status)) {
                    return
                }

                ModalUtils.showErrorModalFromErrorResponse(error)
            } else {
                ModalUtils.showErrorModal(error)
            }
        }
    }

    static handleErrors(response: EntityIdentifierWithErrorResponse[]): void {
        const errors = groupBy(response, 'errorMessage')
        let errorMessages = ''
        Object.keys(errors).forEach(key => {
            errorMessages += `${key} \n`
        })
        ModalUtils.showErrorModal(errorMessages)
    }

    /** @deprecated */
    static async toCall(promise: Promise<any>, showError: boolean = false): Promise<any[]> {
        return promise
            .then(data => {
                if (showError && data.length && data[0].id && data[0].errorMessage) {
                    this.handleErrors(data)
                    return [data]
                }
                return [null, data]
            })
            .catch(err => {
                if (showError) {
                    ModalUtils.showErrorModalFromErrorResponse(err)
                }
                return [err]
            })
    }

    static async toCallSecure<T>(
        promise: Promise<T>,
        errorHandler = (error: any): void => this.handleAxiosError(error)
    ): Promise<T | null> {
        try {
            const data = await promise
            if (Array.isArray(data) &&
                data.length &&
                PromiseUtils.isEntityIdentifierWithErrorResponse(data[0])) {
                this.handleErrors(data)
            }
            return data
        } catch (err) {
            errorHandler(err)
            return null
        }
    }

    static async toCallSecureLoading<T>(promise: Promise<T>, errorHandler?: (error: any) => void): Promise<T | null> {
        const resolved = await this.toCallSecure<T>(promise, errorHandler)
        if (resolved === null) {
            StoreUtils.updateLoading(false)
        }
        return resolved
    }

    static async toCallUnique<T>(promise: Promise<T>, errorHandler?: (error: any) => void): Promise<T | null> {
        StoreUtils.updateLoading(true)
        try {
            return await this.toCallSecureLoading<T>(promise, errorHandler)
        } finally {
            StoreUtils.updateLoading(false)
        }
    }
}
